import { render, staticRenderFns } from "./TemplateEditor.vue?vue&type=template&id=1a563e0a&scoped=true"
import script from "./TemplateEditor.vue?vue&type=script&lang=js"
export * from "./TemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./TemplateEditor.vue?vue&type=style&index=0&id=1a563e0a&prod&lang=stylus&scoped=true"
import style1 from "src/styles/tiptap-styles.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a563e0a",
  null
  
)

export default component.exports